export default "__VITE_ASSET__C0l64owa__"